import { BUSINESS_GROUP_CODES, DMM_BUSINESS_SEGMENT_ORDER } from 'src/constants/business-group-constants';
import { CORP_SEGMENTS_SEQUENCE, CorpSegmentNames } from 'src/constants/corp-segment-constants';
import { DMMBusinessSegmentType } from 'src/models/DmmModel';

/**
 * Sorts corp segments according to the predefined CORP_SEGMENTS_SEQUENCE order.
 * Segments not in the sequence are sorted alphabetically after sequenced ones.
 */
export const customCorpSegmentSort = (a: { corp_segment_name: string }, b: { corp_segment_name: string }): number => {
  const indexA = CORP_SEGMENTS_SEQUENCE.indexOf(a.corp_segment_name as CorpSegmentNames);
  const indexB = CORP_SEGMENTS_SEQUENCE.indexOf(b.corp_segment_name as CorpSegmentNames);

  if (indexA !== -1 && indexB !== -1) return indexA - indexB;
  if (indexA !== -1) return -1;
  if (indexB !== -1) return 1;

  return a.corp_segment_name.localeCompare(b.corp_segment_name);
};

/**
 * Sorts business segments based on business group type.
 * DMM groups follow DMM_BUSINESS_SEGMENT_ORDER; others sort alphabetically.
 */
export const customBusinessSegmentSort = (
  a: { business_segment_name: string },
  b: { business_segment_name: string },
  businessGroupShortDesc?: string
): number => {
  if (businessGroupShortDesc === BUSINESS_GROUP_CODES.DMM) {
    const orderValues = DMM_BUSINESS_SEGMENT_ORDER.slice(1);
    const indexA = orderValues.indexOf(a.business_segment_name as DMMBusinessSegmentType);
    const indexB = orderValues.indexOf(b.business_segment_name as DMMBusinessSegmentType);

    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
  }

  return a.business_segment_name.localeCompare(b.business_segment_name);
};
